// Pequeño helper de feedback sonoro para la estación de recepción.
// El repo no tiene utilidad de audio, así que generamos tonos con WebAudio.
// Un pitido claro por escaneo evita que el operador tenga que mirar la pantalla.

let ctx = null;

function ensureCtx() {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function tone(ac, freq, startOffset, dur, gain = 0.07) {
  const t0 = ac.currentTime + startOffset;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = "sine";
  osc.frequency.setValueAtTime(freq, t0);
  // envolvente corta para que suene "tic" y no zumbido
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(gain, t0 + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g);
  g.connect(ac.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.02);
}

const SEQUENCES = {
  // dos notas ascendentes -> éxito
  success: [[880, 0, 0.09], [1320, 0.1, 0.13]],
  // nota media única -> repetido
  duplicate: [[620, 0, 0.14]],
  // dos notas iguales -> ya estaba recolectado
  already: [[540, 0, 0.1], [540, 0.14, 0.1]],
  // grave descendente -> error / no encontrado
  notfound: [[240, 0, 0.18], [170, 0.2, 0.24]],
};

export function playBeep(kind) {
  try {
    const ac = ensureCtx();
    if (!ac) return;
    const seq = SEQUENCES[kind] || SEQUENCES.success;
    seq.forEach(([f, o, d]) => tone(ac, f, o, d));
  } catch (_) {
    /* audio no disponible: silencio, sin romper el flujo */
  }
}
